/**
 * Dah Back Office API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface OrganizationSectionModel { 
    id?: string;
    name?: string;
    number?: string;
    type?: OrganizationSectionModel.TypeEnum;
    firstFloor?: number;
    lastFloor?: number;
}
export namespace OrganizationSectionModel {
    export const TypeEnum = {
        Section: 'SECTION',
        Housing: 'HOUSING',
        Entrance: 'ENTRANCE',
        Parking: 'PARKING',
        Front: 'FRONT',
        Line: 'LINE',
        Row: 'ROW'
    } as const;
    export type TypeEnum = typeof TypeEnum[keyof typeof TypeEnum];
}


